import React from 'react';
import 'assets/css/App.css';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import {AdminLayout, BlankLayout} from 'layouts';
import {NotFound} from 'modules';
import EfeMenuProvider from 'providers/efe-menu-provider/EfeMenuProvider';
import {EfeCatalogProvider} from 'providers';
import DisableNumInputScroll from 'commons/defaults/disable-num-Input-scroll';

export default function App() {
    return (
        <BrowserRouter>
            <DisableNumInputScroll />
            <Switch>
                <Route exact path={'/'}>
                    <Redirect to={'/admin/login'} />
                </Route>
                <Route path={'/admin'}>
                    <EfeMenuProvider>
                        <EfeCatalogProvider>
                            <AdminLayout />
                        </EfeCatalogProvider>
                    </EfeMenuProvider>
                </Route>
                <Route path={'/blank'}>
                    <BlankLayout />
                </Route>
                <Route path={'*'} component={NotFound} />
            </Switch>
        </BrowserRouter>
    );
}
